<template>
	<div class="Home">
		<!-- 轮播 -->
		<div class="swiper pr">
			<el-carousel ref="carousel" :indicator-position="'none'" :arrow="'never'" :pause-on-hover="false"
				:autoplay="false" @change="swiper" :key="key">
				<el-carousel-item v-for="(x,i) in 4" :key="i">
					<div class="banner" :style="{'backgroundImage': 'url('+require('../assets/banner_'+x+'.jpg')+')'}">
					</div>
				</el-carousel-item>

				<div class="indicator tz hidden-xs-only">
					<span class="arrow arrow_l"
						:style="{backgroundImage: 'url('+require('../assets/swiper_item_arrow_l.png')+')'}"
						@click="swiperMove(0)"></span>
					<span>
						<span class="indicator_item" v-for="(x,i) in 4" :key="i"
							:class="{'indicator_item_active': i == swiper_active}"
							@click="swiperSetActiveItem(i)"></span>
					</span>
					<span class="arrow arrow_r"
						:style="{backgroundImage: 'url('+require('../assets/swiper_item_arrow_r.png')+')'}"
						@click="swiperMove(1)"></span>
				</div>
			</el-carousel>

			<div class="swiper_box ff">
				<div class="swiper_box_item">
					<div class="f28">21年</div>
					<div class="f18 o8">行业经验</div>
				</div>
				<div class="swiper_box_item">
					<div class="f28">600+</div>
					<div class="f18 o8">合作客户</div>
				</div>
				<div class="swiper_box_item" style="border-color: rgba(255,255,255,0);">
					<div class="f28">7*24小时</div>
					<div class="f18 o8">专业服务</div>
				</div>
				<div class="cl"></div>
			</div>
		</div>

		<!-- 业务功能 -->
		<div class="title">业务功能</div>
		<div class="Business_home">
			<template v-for="i in 4">
				<div class="w50 fl">
					<div class="Business_item" @click="Business(i)">
						<div v-if="i == 1" class="Business_title">
							<div class="f26">物流规划咨询</div>
							<div class="f16">集合行业智慧，为客户提供生产物流规划、物流园区规划设计、<span class="hidden-xs-only"><br /></span>物流企业管理咨询、物流业务流程优化等服务。</div>
						</div>
						<div v-if="i == 2" class="Business_title">
							<div class="f26">智能装备制造与集成</div>
							<div class="f16">通过智能技术和智能装备的有效应用，实现客户<span class="hidden-xs-only"><br /></span>个性化服务的标准化。</div>
						</div>
						<div v-if="i == 3" class="Business_title">
							<div class="f26">智慧物流软件开发</div>
							<div class="f16">为客户提供软件开发、信息化解决方案设计、企业管理模式设计、<span class="hidden-xs-only"><br /></span>业务流程重组等服务，帮助客户实现全面数字化与网络化。</div>
						</div>
						<div v-if="i == 4" class="Business_title">
							<div class="f26">供应链服务</div>
							<div class="f16">依据客户的不同要求，提供运输、仓储、内外物流配送等相关服务。<span class="hidden-xs-only"><br /></span>助您节拍提升、产能提升、降低物流成本。</div>
						</div>
						<img :src="require('../assets/Business_item_'+i+'.jpg')" class="w100 vt" />
						<img :src="require('../assets/Business_item_'+i+'.jpg')" class="img vt" />
					</div>
				</div>
			</template>
			<div class="cl"></div>
		</div>

		<!-- 公司动态 -->
		<div class="title">公司动态</div>
		<div class="News_home">
			<div class="content">
				<el-row :gutter="15">
					<template v-for="(x,i) in newsList">
						<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-if="i < 6">
							<div class="News_item bor1 cp pr tran3" @click="newsLook(x)">
								<div class="News_item_img">
									<el-image style="width: 100%; height: 245px;vertical-align: top;"
										:src="require(`@/assets/News_item_${x.img_index[0]+1}.jpg`)" :fit="x.img_index[0] == 15 ? 'fill' : 'cover'"></el-image>
								</div>
								<div class="News_item_arrow oh">
									<img src="../assets/News_item_arrow.png" class="fr tran3" />
								</div>
								<div class="News_item_content lh7 c3">
									<div class="f18 b mb5 hang1" :title="x.title">{{x.title}}</div>
									<div class="f16 hang2" :title="x.descr" style="height: 55px;">{{x.descr}}</div>
								</div>
							</div>
						</el-col>
					</template>
				</el-row>
			</div>
		</div>
		<el-dialog title="" v-model="newsShow" destroy-on-close width="63%" :show-close="false"
			:close-on-click-modal="true" @open="$opened(this)">
			<div class="window">
				<div class="tz borb1">
					<div class="f30 b c3">{{newsDialog.title}}</div>
					<div class="f14 c9 ptb20">发布日期： {{newsDialog.date}}</div>
				</div>
				<div class="window_content" v-html="newsDialog.html"></div>
				<template v-if="newsDialog.videoList" v-for="url in newsDialog.videoList">
					<div class="img tz mt20">
						<video :src="url" controls :poster="newsDialog.imgList[0]" preload="metadata" style="width: 100%;"></video>
					</div>
				</template>
				<template v-else v-for="url in newsDialog.imgList">
					<div class="img tz mt20">
						<img :src="url" style="width: 100%;" />
					</div>
				</template>
				<div class="close bluebg" @click="newsShow = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</el-dialog>

		<div class="more" @click="link('News')">了解更多</div>

		<!-- 经典案例 -->
		<div class="title">经典案例</div>
		<div class="Case_home">
			<div class="content pr oh" :style="{'height': '384px'}">
				<el-row>
					<template v-for="i in 4">
						<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
							<el-carousel :ref="'carouselCase_'+i" :indicator-position="'none'" :arrow="'never'"
								:pause-on-hover="false" :autoplay="false" :initial-index="i-1" :height="'384px'"
								:key="key">
								<el-carousel-item v-for="(x,n) in caseList" :key="n"
									style="border-left: 1px solid #fff;">
									<div class="Case_item" :alt="x.title" @click="caseLook(x)">
										<el-image style="width: 100%; height: 384px;vertical-align: top;" :src="require(`@/assets/Case_${n+1}.jpg`)"
											:fit="'cover'"></el-image>
									</div>
								</el-carousel-item>
							</el-carousel>
						</el-col>
					</template>
				</el-row>

				<div class="indicatorCase">
					<div class="indicatorCase_left" @click="CaseMove(0)"></div>
					<div class="indicatorCase_right" @click="CaseMove(1)"></div>
				</div>
			</div>
		</div>
		<el-dialog title="" v-model="caseShow" destroy-on-close width="1200px" :show-close="false"
			:close-on-click-modal="true" @open="$opened(this)">
			<div class="window">
				<div class="tz borb1">
					<div class="f30 b c3">{{caseDialog.title}}</div>
					<div class="f14 c9 ptb20">发布日期： {{caseDialog.date}}</div>
				</div>
				<div class="img tz mt20">
					<img :src="caseDialog.img" style="max-width: 80%;" />
				</div>
				<div class="tz ptb20 f18">{{caseDialog.descr}}</div>
				<div class="window_content" v-html="caseDialog.html"></div>
				<div class="close bluebg" @click="caseShow = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</el-dialog>

		<div class="pb20"></div>
		<div class="more" @click="link('Case')">了解更多</div>

		<!-- 浪 -->
		<div class="Lang" id="Lang">
			<div class="content pr oh">
				<div class="pr" style="z-index: 10;">
					<div>
						<div class="bluebg Lang_info lh7 ff fl">
							<div class="f24 b mb25">{{state.name}}</div>
							<div class="f16 mb25">
								长春市大众物流装配有限责任公司成立于2001年7月，是国家级高新技术企业和吉林省科技小巨人企业，专业为生产型企业提供物流规划、软件开发、AGV制造与集成、产前产中供应链等物流智能化服务。
							</div>
							<div class="more fl m0i light" @click="link('GSJJ')">了解更多</div>
							<div class="cl"></div>
						</div>
						<div class="fr hidden-xs-only">
							<img src="../assets/Lang_1.png" class="Lang_img" @load="langLoad" />
						</div>
						<div class="cl"></div>
					</div>
				</div>
			</div>
			<div class="Lang_Canvas oh hidden-xs-only">
				<LangCanvas />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			LangCanvas: window.$in('components/LangCanvas.vue')
		},
		data() {
			return {
				key: 0,
				swiper_active: 0,
				swiper_height: 980,
				swiper_interval: '',
				newsList: [],
				newsDialog: {},
				newsShow: false,

				caseList: [],
				caseRef: [],
				caseInterval: '',
				caseHeight: 0,
				caseTimeout: false,
				caseDialog: {},
				caseShow: false,
			}
		},
		computed: {
			state() {
				return this.$store.state
			}
		},
		created() {
			this.newsList = this.$store.state.newsList;
			this.newsList.forEach((x,i) => {
				x.imgList = x.img_index.map(m => require(`@/assets/News_item_${m+1}.jpg`));
				if (x.video_index) {
					x.videoList = x.video_index.map(m => require(`@/assets/News_item_${m+1}.mp4`));
				}
			})
			this.caseList = this.$store.state.caseList;
			this.caseList.forEach((x,i) => {
				x.img = require(`@/assets/Case_${i+1}.jpg`)
			})
		},
		mounted() {
			this.bannerScroll();
			this.initcaseInterval();
			this.initSwiperInterval();
			let self = this;
			window.addEventListener('scroll', this.bannerScroll, true)
			window.addEventListener('resize', this.onWindowResize, false);
		},
		unmounted() {
			clearInterval(this.caseInterval)
			clearInterval(this.swiper_interval)
			window.removeEventListener('scroll', this.bannerScroll)
			window.removeEventListener('resize', this.onWindowResize)
		},
		methods: {
			langLoad() {
				this.$set('langCanvasLoad', true);
			},
			onWindowResize() {
				this.$nextTick(() => {
					this.key++;
					try {
						this.caseHeight = this.$refs['Case_img'].clientHeight;
					} catch (e) {}
				})
			},
			bannerScroll(e) {
				// var banners = document.getElementsByClassName('banner');
				// var over = 100;
				// if (e) {
				// 	try{
				// 		var scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
				// 		if (scrollTop < 1400) {
				// 			var y = scrollTop > over ? (scrollTop - over) : 0;
				// 			for (let i = 0; i < banners.length; i++) {
				// 				banners[i].style.transform = "translate3d(0,"+(y/36)+"%,0)";
				// 			}
				// 		}
				// 	}catch(e){}
				// }
			},
			swiper(active) {
				this.swiper_active = active
			},
			initcaseInterval() {
				let caseRef = [];
				for (let k in this.$refs) {
					if (k.includes('carouselCase')) {
						caseRef.push(k)
					}
				}
				this.caseRef = caseRef;
				clearInterval(this.caseInterval)
				this.caseInterval = setInterval(() => {
					caseRef.forEach(x => {
						try {
							this.$refs[x].next()
						} catch (err) {
							this.$refs[x][0].next()
						}
					})
				}, 3000)
			},
			CaseImgLoad(e) {
				console.log(e)
				if (!this.caseHeight) {
					// this.caseHeight = e.target.height
				}
			},
			CaseMove(m) {
				if (this.caseTimeout) {
					return
				}
				this.caseTimeout = true
				setTimeout(() => {
					this.caseTimeout = false
				}, 500)
				clearInterval(this.caseInterval)
				this.caseRef.forEach(x => {
					if (m) {
						try {
							this.$refs[x].next()
						} catch (err) {
							this.$refs[x][0].next()
						}
					} else {
						try {
							this.$refs[x].prev()
						} catch (err) {
							this.$refs[x][0].prev()
						}
					}
				})
				this.$nextTick(() => {
					setTimeout(() => {
						this.initcaseInterval();
					}, 500)
				})
			},
			swiperMove(m) {
				if (m) {
					this.$refs['carousel'].next()
				} else {
					this.$refs['carousel'].prev()
				}
				clearInterval(this.swiper_interval)
				this.initSwiperInterval()
			},
			swiperSetActiveItem(i) {
				this.$refs['carousel'].setActiveItem(i)
				this.initSwiperInterval()
			},
			initSwiperInterval() {
				clearInterval(this.swiper_interval)
				this.swiper_interval = setInterval(() => {
					this.$refs['carousel'].next()
				}, 3000)
			},
			swiperImgLoad(e) {
				// if (!this.swiper_height) {
				// 	this.swiper_height = e.height
				// }
			},
			Business(i) {
				if (i == 1) {
					this.link('WLGHZX')
				} else if (i == 2) {
					this.link('ZNZBZZYJC')
				} else if (i == 3) {
					this.link('ZHWLRJKF')
				} else if (i == 4) {
					this.link('GYLFW')
				}
			},
			link(name) {
				this.$router.push({
					name: name
				});
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			newsLook(item) {
				this.newsShow = true;
				this.newsDialog = item;
			},
			caseLook(item) {
				this.caseShow = true;
				this.caseDialog = item;
			},
		}
	}
</script>

<style lang="scss">
	.Home {
		.swiper {
			@media screen and (max-width: 768px) {
				margin-bottom: 2vw;
			}
			
			.el-carousel__container {
				height: 937px;

				@media screen and (max-width: 1570px) {
					height: 815px;
				}

				@media screen and (max-width: 1200px) {
					height: 750px;
				}

				@media screen and (max-width: 768px) {
					height: calc(100vw / 1.57);
				}
			}

			.banner {
				background-repeat: no-repeat;
				background-position: center;
				background-size: cover;
				// background-attachment: fixed;
				height: 937px;

				@media screen and (max-width: 1570px) {
					height: 815px;
				}

				@media screen and (max-width: 1200px) {
					height: 750px;
				}

				@media screen and (max-width: 768px) {
					height: calc(100vw / 1.57);
				}
			}



			.swiper_box {
				position: absolute;
				bottom: 90px;
				left: 0;
				right: 0;
				text-align: center;
				width: 1200px;

				@media screen and (max-width: 1200px) {
					width: 1100px;
				}

				@media screen and (max-width: 768px) {
					width: 100%;
					padding: 0 0 10px;
					bottom: 0;
					// transform: scale(0.7);

					.f28 {
						font-size: 16px;
					}

					.f18 {
						font-size: 12px;
					}

					&::after,
					&::before {
						width: 40px !important;
						height: 40px !important;
						display: none;
					}
				}

				margin: 0 auto;
				padding: 0 100px 10px;
				box-sizing: border-box;

				&::after {
					position: absolute;
					content: ' ';
					right: 0;
					bottom: 0;
					width: 60px;
					height: 60px;
					border-right: 3px solid #FFFFFF;
					border-bottom: 3px solid #FFFFFF;
				}

				&::before {
					position: absolute;
					content: ' ';
					left: 0;
					bottom: 0;
					width: 60px;
					height: 60px;
					border-left: 3px solid #FFFFFF;
					border-bottom: 3px solid #FFFFFF;
				}
			}

			.swiper_box_item {
				float: left;
				width: 33.33%;
				line-height: 1.5;
				border-right: 2px solid #FFFFFF;
				box-sizing: inherit;
			}

			.indicator {
				position: absolute;
				left: 0;
				right: 0;
				bottom: 40px;

				.indicator_item {
					height: 20px;
					width: 10px;
					position: relative;
					display: inline-block;
					margin: 0 6px;
					cursor: pointer;

					&::after {
						position: absolute;
						content: ' ';
						left: 4px;
						right: 4px;
						bottom: 0;
						height: 15px;
						background: #FFFFFF;
						transition: all 0.3s;
						-webkit-transition: all 0.3s;
						opacity: 0.8;
					}

					&:hover {
						&::after {
							height: 20px;
							opacity: 1;
						}
					}
				}

				.indicator_item_active {
					&::after {
						height: 20px;
						background: #e80012;
						opacity: 1;
					}
				}

				.arrow {
					display: inline-block;
					width: 60px;
					height: 20px;
					background-repeat: no-repeat;
					margin: 0 80px;
					cursor: pointer;
					transition: all 0.3s;
					-webkit-transition: all 0.3s;

					&.arrow_l {
						background-position: right center;
					}

					&.arrow_r {
						background-position: left center;
					}

					&:hover {
						background-position: center center;
					}
				}
			}
		}

		.Business_home {
			position: relative;
			padding: 0 2px;

			.Business_item {
				margin: 0 2px 4px 2px;
				box-sizing: border-box;
				// height: calc((50vw - 6px) / 1.85);
				height: auto;
				overflow: hidden;
				position: relative;
				cursor: pointer;
				background-color: #303133;
				color: #FFFFFF;
				transition: all 0.3s;
				-webkit-transition: all 0.3s;

				.img {
					position: absolute;
					width: 100%;
					height: auto;
					left: 50%;
					right: 0;
					top: 50%;
					bottom: 0;
					transform: translate(-50%, -50%);
					-webkit-transform: translate(-50%, -50%);
					transition: all 0.3s;
					-webkit-transition: all 0.3s;
					filter: brightness(100%);
					-webkit-filter: brightness(100%);
				}

				&:hover {
					box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);
					-webkit-box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);

					.img {
						// width: 105%;
						transform: translate(-50%, -50%) scale(1.05);
						-webkit-transform: translate(-50%, -50%) scale(1.05);
						filter: brightness(70%);
						-webkit-filter: brightness(70%);
					}

					.Business_title {
						// top: 80px;
						transform: translateY(10px);
					}
				}

				.Business_title {
					position: absolute;
					top: 70px;
					left: 0;
					right: 0;
					text-align: center;
					line-height: 1.7;
					z-index: 1;
					transition: all 0.3s;
					-webkit-transition: all 0.3s;
				}
			}

			@media screen and (max-width: 768px) {
				padding: 0 2vw;
				.w50 {
					width: 100%;

					.Business_item {
						margin: 0 0 2vw;

						.Business_title {
							top: 13%;

							.f26 {
								font-size: 4.2vw;
							}

							.f16 {
								font-size: 3.6vw;
								max-width: 80%;
								margin: 0 auto;
							}
						}
					}
				}
			}
		}

		.News_home {

			.News_item {
				margin-bottom: 25px;

				.News_item_arrow {
					padding: 13px 15px 3px;
					opacity: 0.5;

					img {
						transform: translate3d(0, 0, 0);
					}
					
					@media screen and (max-width: 768px) {
						opacity: 1;
					}
				}

				.News_item_content {
					padding: 0 15px 15px;
					@media screen and (max-width: 768px) {
						.f18 {
							font-size: 16px;
						}
						.f16 {
							font-size: 14px;
							// height: 50px!important;
							height: auto!important;
							min-height: 50px;
						}
					}
				}

				.News_item_img {
					height: auto;
					overflow: hidden;
					position: relative;

					img {
						transition: all 0.3s;
						-webkit-transition: all 0.3s;
					}

					&::after {
						position: absolute;
						content: ' ';
						left: 0;
						right: 0;
						top: 0;
						bottom: 0;
						background-color: rgba(0, 0, 0, 0.5);
						transition: all 0.3s;
						-webkit-transition: all 0.3s;
						z-index: 1;
						background-image: url(../assets/search.png);
						background-repeat: no-repeat;
						background-size: 36px;
						background-position: 10px 10px;
						background-position: 10px calc(100% - 10px);
						opacity: 0;
						
						
						@media screen and (max-width: 768px) {
							& {
								display: none;
							}
						}
					}
				}

				&:hover {
					box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);
					-webkit-box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);

					.News_item_arrow {
						img {
							transform: translate3d(2px, 0, 0);
						}

						opacity: 1;
					}

					.News_item_img {
						img {
							transform: scale(1.05);
						}

						&::after {
							opacity: 1;
							background-position: 15px 15px;
							background-position: 15px calc(100% - 15px);
						}
					}
					@media screen and (max-width: 768px) {
						box-shadow: none;
						.News_item_img img {
							transform: scale(1);
						}
						.News_item_arrow img {
							transform: translate3d(0, 0, 0);
						}
					}
				}
			}
			
			@media screen and (max-width: 768px) {
				padding: 0 2vw;
				.News_item {
					margin-bottom: 2vw;
				}
			}
		}

		.window {
			padding: 10px 30px 50px;
			box-sizing: border-box;
			background: #FFFFFF;
			position: relative;
		}

		.window_content {
			font-size: 16px;
			line-height: 2;

			p {
				margin-bottom: 20px;
				text-indent: 32px;
			}

			img {
				// max-width: 770px;
				width: 100%;
				margin: 0 auto;
				display: block;
			}

			table {
				border-collapse: collapse;
				border-spacing: 0;
				// border-color: #E6E6E6;
				
				tr:first-of-type {
					background-color: #f2f2f2;
				}
				
				td {
					padding: 2px 8px;
				}
			}
		}

		.close {
			position: absolute;
			width: 50px;
			height: 50px;
			right: -70px;
			top: -60px;
			text-align: center;
			cursor: pointer;

			i {
				font-size: 30px;
				color: #FFFFFF;
				line-height: 50px;
			}
		}

		.Case_home {

			.Case_item {
				position: relative;
				cursor: pointer;

				img {
					transition: all 0.3s;
					-webkit-transition: all 0.3s;
				}

				&:hover {
					img {
						transform: scale(1.05);
					}
				}

				&::before {
					position: absolute;
					content: '';
					left: 1px;
					right: 0;
					top: 0;
					bottom: 0;
					background-color: rgba(0, 0, 0, 0.3);
					z-index: 5;
				}

				&::after {
					position: absolute;
					content: attr(alt);
					text-align: center;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					-webkit-transform: translate(-50%, -50%);
					font-size: 24px;
					color: #FFFFFF;
					line-height: 1.5;
					width: 80%;
					z-index: 10;
				}
			}

			.indicatorCase {
				div {
					position: absolute;
					z-index: 10;
					top: 0;
					bottom: 0;
					height: 100%;
					width: 50px;
					cursor: pointer;
					// background-color: rgba(0, 0, 0, 0.3);
				}

				.indicatorCase_left {
					left: 0;
					background: rgba(0, 0, 0, 0.3) url(~@/assets/Case_arrow_l.png) no-repeat center;
				}

				.indicatorCase_right {
					right: 0;
					background: rgba(0, 0, 0, 0.3) url(~@/assets/Case_arrow_r.png) no-repeat center;
				}
			}
			
			@media screen and (max-width: 768px) {
				padding: 0 2vw;
			}
		}

		.Lang {
			position: relative;

			.Lang_info {
				padding: 30px 25px;
				margin-top: 172px;
				width: 390px;

				@media screen and (max-width: 1570px) {
					margin-top: 70px;
				}
				@media screen and (max-width: 768px) {
					margin-top: 20px;
					margin-bottom: 40px;
					width: 100%;
					box-sizing: border-box;
					text-align: center;
					.more {
						margin: 0 auto!important;
						float: none;
						text-align: left;
					}
					.f24 {
						font-size: 18px;
						margin-bottom: 10px;
					}
					.f16 {
						text-align: justify;
						margin-bottom: 10px;
					}
				}
			}

			.Lang_img {
				margin-right: 100px;

				@media screen and (max-width: 1570px) {
					width: 450px;
				}
				@media screen and (max-width: 1200px) {
					width: 400px;
				}
				@media screen and (max-width: 768px) {
					width: 100%;
					margin: 0;
					transform: scale(0.7);
				}
			}

			.Lang_Canvas {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
			}
		}

	}
</style>
